var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74995 11C5.74995 11.3452 6.02977 11.625 6.37495 11.625C6.72013 11.625 6.99995 11.3452 6.99995 11L6.99995 6.625L11.375 6.625C11.7202 6.625 12 6.34518 12 6C12 5.65482 11.7202 5.375 11.375 5.375L6.99995 5.375V1C6.99995 0.654822 6.72013 0.375 6.37495 0.375C6.02977 0.375 5.74995 0.654822 5.74995 1V5.375H1.375C1.02982 5.375 0.75 5.65482 0.75 6C0.75 6.34518 1.02982 6.625 1.375 6.625H5.74995L5.74995 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.5daf4f14662b2ae189e942fad46171a2.svg";
export { ForwardRef as ReactComponent };